export default {
  apiKey: "AIzaSyDcUPszGFyVwzippGU8WV0o-1-P8yCP0Wk",
  authDomain: "emc-mdnacloud-nrfdemo-poc-t.firebaseapp.com",
  projectId: "emc-mdnacloud-nrfdemo-poc-t",
  storageBucket: "emc-mdnacloud-nrfdemo-poc-t.appspot.com",
  messagingSenderId: "1005053605890",
  appId: "1:1005053605890:web:f937648a8bf7b509f2cf1b",
  measurementId: "G-GPR5SQETW1"
}